<template>
  <!-- <div class="container-fluid">
    <div class="master-layout-container"> -->
      <div class="main-content">
        <slot name="breadcrumbs" v-if="$mq != 'sm'"></slot>
        <header v-if="enableHeader">
          <slot name="header"></slot>
        </header>
        <div class="table-view__notifications">
          <slot name="notifications"/>
        </div>
        <main>
          <slot></slot>
        </main>
      <!-- </div> -->
      <!-- <master-side-nav v-if="enableSideNav" :showQuickSetup="showQuickSetup" :sideNavType="sideNavType" :navLinks="navLinks"></master-side-nav> -->
    <!-- </div> -->
  </div>
</template>

<script>
export default {
  name: 'TableView',
  // components: { MasterSideNav },
  props: {
    showQuickSetup: {
      type: Boolean,
      default: true
    },
    enableSideNav: {
      type: Boolean,
      default: true
    },
    enableHeader: {
      type: Boolean,
      default: true
    },
    enableFooter: {
      type: Boolean,
      default: true
    },
    navLinks: {
      type: Array,
      default: () => ([])
    }
  },
  data () {
    return {
      sideNavType: 'Merchant'
    }
  }
}
</script>

<style scoped lang="scss">
 @import '../../../assets/scss/shipbob-custom/components/layout/_master-layout.scss';
</style>
